import * as UI from "@iyk/ui"
import * as React from "react"

import { useLocation } from "react-router"
import { Card } from "../../../packages/card.tsx"
import { LogoutButton } from "../../auth/logout-button.tsx"
import { VerifiedProfileIcon } from "./icons.tsx"
import { Link, Routes } from "./link.tsx"
import { Sheet } from "./sheet.tsx"

export const UserMenu = (props: UserMenu.Props) => {
  const currentRoute = useLocation().pathname

  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <Sheet.Root open={isOpen} onOpenChange={setIsOpen}>
      <Sheet.Trigger asChild>
        <UI.Button type="button" kind="shaded" size="sm">
          <UI.Icon.Profile />
        </UI.Button>
      </Sheet.Trigger>
      <Sheet.Content title="Profile" description="Manage your profile">
        <div className="flex flex-col gap-4 px-4 pt-10 pb-4">
          <Card className="flex justify-between p-4">
            <div className="flex items-center gap-2">
              <span className="text-[18px] leading-6 uppercase font-departure-mono">
                {props.username}
              </span>
              <VerifiedProfileIcon />
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <UI.Icon.Location />
                <span className="text-xs">{props.showCount}</span>
              </div>
              <div className="flex items-center gap-2">
                <UI.Icon.Badge />
                <span className="text-xs">{props.merchCount}</span>
              </div>
            </div>
          </Card>
          <div className="w-full flex flex-col">
            <Link
              to={Routes.home}
              className={classForMenuAction}
              onClick={(e) => {
                if (currentRoute === Routes.home) {
                  e.preventDefault()
                }
                setIsOpen(false)
              }}
            >
              My Profile
            </Link>
            <LogoutButton formClassName={classForMenuAction} buttonClassName="flex-1 text-left" />
          </div>
        </div>
      </Sheet.Content>
    </Sheet.Root>
  )
}

const classForMenuAction = UI.cx(
  "w-full h-12 cursor-pointer text-sm text-gray-11 flex items-center",
)

namespace UserMenu {
  export type Props = {
    userId: string
    username: string
    showCount: number
    merchCount: number
  }
}
